import makeStyles from '@material-ui/core/styles/makeStyles';
import { fade } from '@material-ui/core';

export default makeStyles((theme) => ({
  root: {
    border: '1px solid #e2e2e1',
    overflow: 'hidden',
    borderRadius: 5,
    backgroundColor: '#fcfcfb',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:hover': {
      backgroundColor: '#fff',
    },
    '&.Mui-focused': {
      backgroundColor: '#fff',
      boxShadow: `${fade(theme.palette.secondary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.secondary.main,
    },
  },
  rootMultiline: {
    alignItems: 'start',
    height: 550,
  },
  rootFullWidth: {
    width: '100%'
  },
  rootError: {
    '&$error': {
      color: theme.palette.secondary.main
    }
  },
  redRootError: {
    '&$error': {
      color: "#fff"
    }
  },
  error: {
  },
  icon: {
    marginRight: 5
  },
  mainContainer: {
    height: 90
  },
  fullWidthContainer: {
    width: '100%'
  },
  multiLineContainer: {
    height: 580
  },
  form: {
    width: '100%'
  },
  helperText: {
    display: 'flex',
    alignItems: 'center'
  }
}));
